import { AuthPartialStoreState } from '../auth.reducer';

export const getLoading = (state: AuthPartialStoreState) => state.auth.changePassword.loading;

export const getError = (state: AuthPartialStoreState) => state.auth.changePassword.error;

export const getDone = (state: AuthPartialStoreState) => state.auth.changePassword.done;

export const getIsSubmitted = (state: AuthPartialStoreState) => state.auth.changePassword.isSubmitted;
